import { observer }                         from 'mobx-react';
import { getStandDocumentMediaStatusLabel } from 'constants/StandDocumentMediaStatuses';
import { getStandDocumentMediaStatusColor } from 'constants/StandDocumentMediaStatuses';
import StandDocumentMediaModel              from 'models/StandDocumentMediaModel';
import StandDocumentMediaStatusModel        from 'models/StandDocumentMediaStatusModel';
import { ApiCollection }                    from 'collections/ApiCollection';

const StandDocumentMediaStatus = observer(
  ({ standDocumentMedia, standDocumentMediaStatusCollection }: { standDocumentMedia: StandDocumentMediaModel, standDocumentMediaStatusCollection: ApiCollection<StandDocumentMediaStatusModel> }) => {
    const standDocumentMediaStatus = standDocumentMediaStatusCollection.find(
      sdms => sdms.id === standDocumentMedia.standDocumentMediaStatusId,
    );

    if (!standDocumentMediaStatus) {
      return null;
    }

    return (
      <div style={{ display: 'flex' }}>
        <div
          style={{
            backgroundColor: getStandDocumentMediaStatusColor(standDocumentMediaStatus.reference),
            borderRadius: 7.5,
            height: 15,
            margin: '0px 5px 0px 0px',
            position: 'relative',
            top: 3,
            width: 15,
          }}
        />
        {getStandDocumentMediaStatusLabel(standDocumentMediaStatus.reference)}
      </div>
    );
  },
);

export default StandDocumentMediaStatus;
